module.exports = __webpack_public_path__ + "img/skip_hover.b2f10cf2.png";